// extracted by mini-css-extract-plugin
export default {"app":"oosbO","scrollable":"_2US15","baseStyles":"_30gmQ","mobileBaseStyles":"_1GhlL"};